import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

const theme = {
  primary: '#34495e',
  secondary: '#2c3e50',
  accent: '#9b59b6',
  info: '#3498db'
}

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  }
})
